import { OnchainAsset } from './onchainTypes';

const ETHERSCAN_API_KEY = process.env.ETHERSCAN_API_KEY || 'YOUR_ETHERSCAN_API_KEY';
const ETHERSCAN_BASE = 'https://api.etherscan.io/api';

export async function readEvmWalletAssets(address: string, walletId: string): Promise<OnchainAsset[]> {
  const assets: OnchainAsset[] = [];
  // 1. Solde ETH
  const ethRes = await fetch(`${ETHERSCAN_BASE}?module=account&action=balance&address=${address}&apikey=${ETHERSCAN_API_KEY}`);
  const ethData = await ethRes.json();
  if (ethData.status === '1' && ethData.result) {
    const ethBalance = parseFloat(ethData.result) / 1e18;
    if (ethBalance > 0.0001) {
      assets.push({ symbol: 'ETH', quantity: ethBalance, chain: 'ethereum', walletId });
    }
  }
  // 2. Tokens ERC20
  const tokenRes = await fetch(`${ETHERSCAN_BASE}?module=account&action=tokentx&address=${address}&apikey=${ETHERSCAN_API_KEY}`);
  const tokenData = await tokenRes.json();
  if (tokenData.status === '1' && Array.isArray(tokenData.result)) {
    const tokenMap: Record<string, { symbol: string; contractAddress: string; quantity: number }> = {};
    for (const tx of tokenData.result) {
      if (!tx.tokenSymbol || !tx.contractAddress) continue;
      const qty = parseFloat(tx.value) / Math.pow(10, parseInt(tx.tokenDecimal));
      if (!tokenMap[tx.contractAddress]) {
        tokenMap[tx.contractAddress] = { symbol: tx.tokenSymbol, contractAddress: tx.contractAddress, quantity: 0 };
      }
      // Ajoute ou soustrait selon le sens de la transaction
      if (tx.to.toLowerCase() === address.toLowerCase()) {
        tokenMap[tx.contractAddress].quantity += qty;
      } else if (tx.from.toLowerCase() === address.toLowerCase()) {
        tokenMap[tx.contractAddress].quantity -= qty;
      }
    }
    // Filtre tokens avec quantité > 0.0001
    for (const token of Object.values(tokenMap)) {
      if (token.quantity > 0.0001) {
        assets.push({ symbol: token.symbol, contractAddress: token.contractAddress, quantity: token.quantity, chain: 'ethereum', walletId });
      }
    }
  }
  return assets;
}
